// To do: Consider removing it.
// Can you anchor for new tab
// Can you native react router -> navigate hook directly.
import { NavigateFunction } from 'react-router'
import { NAVIGATION } from '../analytics'
import { trackMixpanelAction } from '../analytics'
import { NavTitle } from '../types/global'

export const openNewPage = (uri: string, screenName?: string, routeName?: string) => () => {
  // Track the Mixpanel event
  if (screenName) {
    const menuItemTitle = screenName.replace(/ /g, '_').toUpperCase()
    trackMixpanelAction(NAVIGATION.ACTION[`NAVIGATE_${menuItemTitle}`], {
      Screen: NAVIGATION.SCREEN_NAME[menuItemTitle],
      DestinationRoute: uri,
      FromRoute: routeName ?? '',
    })
  }
  window.open(uri, '_blank')
}

export const openPage = (uri: string, screenName?: string, routeName?: string) => () => {
  // Track the Mixpanel event
  if (screenName) {
    const menuItemTitle = screenName.replace(/ /g, '_').toUpperCase()
    trackMixpanelAction(NAVIGATION.ACTION[`NAVIGATE_${menuItemTitle}`], {
      Screen: NAVIGATION.SCREEN_NAME[menuItemTitle],
      DestinationRoute: uri,
      FromRoute: routeName ?? '',
    })
  }
  window.location.replace(uri)
}

export const navigateRoute =
  (navigateFn: NavigateFunction, route: string, menuItemTitle?: NavTitle, routeName?: string) => (): void => {
    // Track the Mixpanel event
    if (menuItemTitle) {
      const formattedTitle = menuItemTitle.replace(/ /g, '_').toUpperCase()
      trackMixpanelAction(NAVIGATION.ACTION[`NAVIGATE_${formattedTitle}`], {
        DestinationRoute: route,
        FromRoute: routeName ?? '',
      })
    }
    navigateFn(route)
  }
